// extracted by mini-css-extract-plugin
module.exports = {"profilePicture":"ProfilePicture_profilePicture__35BBH"};